export default {
  titleFontSize: '18px',
  padding: '16px 28px 20px 28px',
  iconSize: '28px',
  actionSpace: '12px',
  contentMargin: '8px 0 16px 0',
  iconMargin: '0 4px 0 0',
  iconMarginIconTop: '4px 0 8px 0',
  closeSize: '22px',
  closeIconSize: '18px',
  closeMargin: '20px 26px 0 0',
  closeMarginIconTop: '10px 16px 0 0'
};